export enum PaymentSort {
  'payment_details' = 'pd',
  'cashback' = 'a',
  'purchases_count' = 'c',
  'payment_method_id' = 'pm',
  'payment_status_id' = 's',
  'date' = 'd',
}
